import { SettingsStorageMixin } from "@/services/storage/storage-mixins/settings-storage-mixin";

export type ConvertBaseSettingsField =
  | "pitch"
  | "removeReverb"
  | "removeInstrumentals"
  | (string & {});

export class ConvertBaseSettingsStorageMixin<
  TField extends ConvertBaseSettingsField,
> extends SettingsStorageMixin<TField> {
  protected setSettingsInternal(
    settings: any,
    value: any,
    field: TField,
  ): void {
    settings[field] = value;
  }
}
